import { GET_E_DOCUTMENTS } from "../../keys";
import {
	infiniteQueryOptions,
	QueryClient,
	useInfiniteQuery,
	useQuery,
} from "@tanstack/react-query";
import {
	getEDocuments,
	EDocumentQueryParams,
} from "@onair/services/e-document";
import { OrderByEnum } from "@onair/repositories";

function edocInfiniteQueryOptions(queryParams?: EDocumentQueryParams) {
	let queryKeyExists: EDocumentQueryParams = {};
	if (queryParams) {
		Object.entries(queryParams).forEach(([key, value]) => {
			if (queryParams[key as keyof EDocumentQueryParams]) {
				queryKeyExists = {
					...queryKeyExists,
					[key]: value,
				};
			}
		});
	}
	const queryKey = [
		GET_E_DOCUTMENTS,
		{ ...queryKeyExists, orderField: "paidCount", order: OrderByEnum.DESC },
	];
	return infiniteQueryOptions({
		queryKey,
		initialPageParam: 1,
		refetchOnMount: true,
		refetchOnWindowFocus: true,
		queryFn: ({ pageParam }) =>
			getEDocuments({ query: { ...queryParams, offset: pageParam } }),
		getNextPageParam: ({ paging: { pageCount, offset } }, allPages) =>
			pageCount > offset ? offset + 1 : null,
	});
}

export const useGetEdocsInfiniteQuery = (queryParams: EDocumentQueryParams) =>
	useInfiniteQuery(edocInfiniteQueryOptions(queryParams));

export const prefetchEDocsInfiniteQuery = async (
	queryClient: QueryClient,
	queryParams?: EDocumentQueryParams,
) => queryClient.prefetchInfiniteQuery(edocInfiniteQueryOptions(queryParams));

export const useGetEDocumentsQuery = (options?: {
	query?: EDocumentQueryParams;
	enabled?: boolean;
}) => {
	const { query, enabled = true } = options || {};
	return useQuery({
		queryKey: [GET_E_DOCUTMENTS, query],
		queryFn: () => getEDocuments({ query }),
		enabled: enabled,
	});
};
